function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { classnames } from '@bydesign-ui/utils';
import React from 'react';
import { usePrefixCls } from '@byte-design/config';
import { Base } from './Base';
export var tupleNum = function tupleNum() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args;
};
var TITLE_ELE_LIST = tupleNum(1, 2, 3, 4, 5, 6);
export function Title(props) {
  var className = props.className,
      _props$level = props.level,
      level = _props$level === void 0 ? 1 : _props$level,
      extra = _objectWithoutProperties(props, ["className", "level"]);

  var component;

  if (TITLE_ELE_LIST.indexOf(level) !== -1) {
    component = 'h' + String(level);
  } else {
    console.error('Title only accept `1 | 2 | 3 | 4 | 5 | 6` as `level` value');
    component = 'h1';
  }

  var cls = classnames(usePrefixCls('typography-title', _defineProperty({}, "h".concat(level), true)), className);
  return React.createElement(Base, Object.assign({}, extra, {
    className: cls,
    strong: true,
    component: component
  }));
}